import TileInterpolator from "./TileInterpolator";

export default TileInterpolator.instance();
